import { useQuery } from '@tanstack/react-query'

import { chatKeys } from '../../keys'
import chatService from '../services'

import type { operations } from '@/schema'

type GetAnalyticsParams =
	operations['ChatController_getAnalytics']['parameters']['query']

export function useQueryChatQuota() {
	return useQuery({
		queryKey: chatKeys.quota(),
		queryFn: () => chatService.getQuota(),
	})
}

export function useQueryChatAnalytics(params?: GetAnalyticsParams) {
	return useQuery({
		queryKey: chatKeys.analytics(params),
		queryFn: () => chatService.getAnalytics(params),
	})
}
